import React from 'react';

import {ClearButton} from '#lib/components/file-dnd.jsx';

export function AudioPreview(props) {
    const {file, clear} = props;

    const clearPreview = () => {
        const confirmClear = confirm(_t.global.confirmDelete());
        if (!confirmClear) return;
        clear();
    }

    return (
        <React.Fragment>
            <ClearButton onClick={clearPreview} />
            <audio controls>
                <source
                    src={file instanceof File ? URL.createObjectURL(file) : file.src}
                    type="audio/mp3"
                />
            </audio>
        </React.Fragment>
    );
}
